module.exports = __webpack_public_path__ + "resources/icon-alert.05e4f77f83c948fe.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/notice-bar/img/icon-alert.png
// module id = 575
// module chunks = 0 1 2 3